export enum EnumTipoPago {
    cuota = 1,
    abono = 2,
    inicial = 3
}